// 普通高等学校本科专业目录（2024年）与研究生教育学科专业目录。
// 数据来源：https://github.com/G00dChina/majorCode
// 生成日期：2026-11-04

export const MAJOR_NAMES: string[] = [
  "阿尔巴尼亚语",
  "阿非利卡语",
  "阿拉伯语",
  "阿姆哈拉语",
  "阿塞拜疆语",
  "爱尔兰语",
  "爱沙尼亚语",
  "安全防范工程",
  "安全工程",
  "安全科学与工程",
  "安全生产监管",
  "白俄罗斯语",
  "白酒酿造工程",
  "包装工程",
  "包装设计",
  "宝石及材料工艺学",
  "保加利亚语",
  "保密管理",
  "保密技术",
  "保险",
  "保险学",
  "比斯拉马语",
  "边防管理",
  "边防指挥",
  "编辑出版学",
  "标准化工程",
  "表演",
  "冰岛语",
  "冰雪舞蹈表演",
  "冰雪运动",
  "兵器科学与技术",
  "波兰语",
  "波斯语",
  "播音与主持艺术",
  "博物馆",
  "材料成型及控制工程",
  "材料化学",
  "材料科学与工程",
  "材料设计科学与工程",
  "材料物理",
  "材料与化工",
  "材料智能技术",
  "财务管理",
  "财务会计教育",
  "财政学",
  "采购管理",
  "采矿工程",
  "蚕学",
  "藏药学",
  "藏医学",
  "草坪科学与工程",
  "草学",
  "草业科学",
  "测绘工程",
  "测绘科学与技术",
  "测控技术与仪器",
  "茶学",
  "产品设计",
  "朝鲜语",
  "车辆工程",
  "城市地下空间工程",
  "城市管理",
  "城市设计",
  "城市水系统工程",
  "城乡规划",
  "城乡规划学",
  "出版",
  "出入境管理",
  "储能科学与工程",
  "畜牧学",
  "传播学",
  "船舶电子电气工程",
  "船舶与海洋工程",
  "创业管理",
  "茨瓦纳语",
  "慈善管理",
  "达里语",
  "大功率半导体科学与工程",
  "大气科学",
  "大数据管理与应用",
  "傣医学",
  "丹麦语",
  "弹药工程与爆炸技术",
  "档案学",
  "导航工程",
  "道路桥梁与渡河工程",
  "德顿语",
  "德语",
  "地理国情监测",
  "地理科学",
  "地理空间信息工程",
  "地理信息科学",
  "地理学",
  "地球化学",
  "地球物理学",
  "地球系统科学",
  "地球信息科学与技术",
  "地下水科学与工程",
  "地质工程",
  "地质学",
  "地质资源与地质工程",
  "迪维希语",
  "电波传播与天线",
  "电磁场与无线技术",
  "电动载运工程",
  "电机电器智能化",
  "电缆工程",
  "电气工程",
  "电气工程及其自动化",
  "电气工程与智能控制",
  "电信工程及管理",
  "电影学",
  "电影制作",
  "电子封装技术",
  "电子竞技运动与管理",
  "电子科学与技术",
  "电子商务",
  "电子商务及法律",
  "电子信息",
  "电子信息材料",
  "电子信息工程",
  "电子信息科学与技术",
  "电子与计算机工程",
  "雕塑",
  "动画",
  "动力工程及工程热物理",
  "动物科学",
  "动物药学",
  "动物医学",
  "动植物检疫",
  "俄语",
  "恩德贝莱语",
  "儿科学",
  "法律",
  "法学",
  "法医学",
  "法语",
  "翻译",
  "反恐警务",
  "犯罪学",
  "梵语巴利语",
  "防灾减灾科学与工程",
  "房地产开发与管理",
  "仿生科学与工程",
  "纺织工程",
  "纺织科学与工程",
  "放射医学",
  "飞行技术",
  "飞行器动力工程",
  "飞行器环境与生命保障工 程",
  "飞行器控制与信息工程",
  "飞行器设计与工程",
  "飞行器适航技术",
  "飞行器运维工程",
  "飞行器制造工程",
  "飞行器质量与可靠性",
  "非物质文化遗产保护",
  "非织造材料与工程",
  "菲律宾语",
  "斐济语",
  "分子科学与工程",
  "芬兰语",
  "粉体材料科学与工程",
  "风景园林",
  "蜂学",
  "服务科学与工程",
  "服装设计与工程",
  "服装设计与工艺教育",
  "服装与服饰设计",
  "辐射防护与核安全",
  "妇幼保健医学",
  "复合材料成型工程",
  "复合材料与工程",
  "港口航道与海岸工程",
  "高分子材料与工程",
  "格鲁吉亚语",
  "给排水科学与工程",
  "工程管理",
  "工程力学",
  "工程软件",
  "工程审计",
  "工程物理",
  "工程造价",
  "工会学",
  "工商管理",
  "工商管理学",
  "工业工程",
  "工业设计",
  "工业智能",
  "工艺美术",
  "公安管理学",
  "公安技术",
  "公安情报学",
  "公安视听技术",
  "公安学",
  "公安政治工作",
  "公共关系学",
  "公共管理",
  "公共管理学",
  "公共事业管理",
  "公共卫生",
  "公共卫生与预防医学",
  "公共艺术",
  "功能材料",
  "供应链管理",
  "孤独症儿童教育",
  "古典文献学",
  "古生物学",
  "古文字学",
  "管理科学",
  "管理科学与工程",
  "光电信息材料与器件",
  "光电信息科学与工程",
  "光学工程",
  "光源与照明",
  "广播电视编导",
  "广播电视工程",
  "广播电视学",
  "广告学",
  "轨道交通电气与控制",
  "轨道交通信号与控制",
  "国际法",
  "国际经济发展合作",
  "国际经济与贸易",
  "国际经贸规则",
  "国际商务",
  "国际事务",
  "国际事务与国际关系",
  "国际税收",
  "国际新闻与传播",
  "国际政治",
  "国际中文教育",
  "国际组织与全球治理",
  "国家安全学",
  "国家公园建设与管理",
  "国民经济管理",
  "国内安全保卫",
  "过程装备与控制工程",
  "哈萨克语",
  "哈医学",
  "海关管理",
  "海关稽查",
  "海关检验检疫安全",
  "海警后勤管理",
  "海警舰艇指挥与技术",
  "海警执法",
  "海事管理",
  "海外安全管理",
  "海外利益安全",
  "海洋工程与技术",
  "海洋机器人",
  "海洋技术",
  "海洋科学",
  "海洋信息工程",
  "海洋药学",
  "海洋油气工程",
  "海洋渔业科学与技术",
  "海洋资源开发技术",
  "海洋资源与环境",
  "汉学与中国学",
  "汉语国际教育",
  "汉语言",
  "汉语言文学",
  "焊接技术与工程",
  "航海技术",
  "航空安防管理",
  "航空服务艺术与管理",
  "航空航天工程",
  "航空宇航科学与技术",
  "豪萨语",
  "合成生物学",
  "核电技术与控制工程",
  "核工程与核技术",
  "核化工与核燃料工程",
  "核科学与技术",
  "核生化消防",
  "核物理",
  "荷兰语",
  "后勤与装备保障",
  "互联网金融",
  "护理",
  "护理学",
  "华文教育",
  "化工安全工程",
  "化学",
  "化学测量学与技术",
  "化学工程与工业生物工程",
  "化学工程与工艺",
  "化学工程与技术",
  "化学生物学",
  "化妆品技术与工程",
  "化妆品科学与技术",
  "环保设备工程",
  "环境工程",
  "环境科学",
  "环境科学与工程",
  "环境设计",
  "环境生态工程",
  "回医学",
  "会计",
  "会计学",
  "会展",
  "会展经济与管理",
  "绘画",
  "火灾勘查",
  "机电技术教育",
  "机器人工程",
  "机械",
  "机械电子工程",
  "机械工程",
  "机械工艺技术",
  "机械设计制造及其自动化",
  "基础医学",
  "吉尔吉斯语",
  "集成电路科学与工程",
  "集成电路设计与集成系统",
  "计算机科学与技术",
  "计算金融",
  "纪检监察",
  "纪检监察学",
  "技术侦查学",
  "加泰罗尼亚语",
  "家具设计与工程",
  "家庭教育",
  "家政学",
  "假肢矫形工程",
  "监狱学",
  "柬埔寨语",
  "建筑",
  "建筑电气与智能化",
  "建筑环境与能源应用工程",
  "建筑学",
  "健康服务与管理",
  "健康科学与技术",
  "交叉工程",
  "交通工程",
  "交通管理",
  "交通管理工程",
  "交通设备与控制工程",
  "交通运输",
  "交通运输工程",
  "教育",
  "教育技术学",
  "教育康复学",
  "教育学",
  "捷克语",
  "金融",
  "金融工程",
  "金融科技",
  "金融审计",
  "金融数学",
  "金融学",
  "金属材料工程",
  "禁毒学",
  "经济动物学",
  "经济犯罪侦查",
  "经济工程",
  "经济林",
  "经济统计学",
  "经济学",
  "经济与金融",
  "精密仪器",
  "精神医学",
  "精算学",
  "精细化工",
  "警犬技术",
  "警卫学",
  "警务",
  "警务指挥与战术",
  "酒店管理",
  "救助与打捞工程",
  "军兵种作战学",
  "军兵种作战指挥",
  "军队政治工作学",
  "军队指挥学",
  "军事管理学",
  "军事海洋学",
  "军事后勤学",
  "军事思想与军事历史",
  "军事训练学",
  "军事训练与管理",
  "军事智能",
  "军事装备学",
  "菌物科学与工程",
  "咖啡科学与工程",
  "勘查技术与工程",
  "康复工程",
  "康复物理治疗",
  "康复治疗学",
  "康复作业治疗",
  "考古学",
  "科技艺术",
  "科摩罗语",
  "科学技术史",
  "科学教育",
  "科学社会主义",
  "科学史",
  "可持续能源",
  "克里奥尔语",
  "克罗地亚语",
  "空间科学与技术",
  "空间信息与数字技术",
  "空天智能电推进技术",
  "控制科学与工程",
  "口腔医学",
  "口腔医学技术",
  "库尔德语",
  "库克群岛毛利语",
  "跨境电子商务",
  "跨媒体艺术",
  "矿物加工工程",
  "矿物资源工程",
  "矿业工程",
  "拉丁语",
  "拉脱维亚语",
  "劳动关系",
  "劳动教育",
  "劳动经济学",
  "劳动与社会保障",
  "老年学",
  "老挝语",
  "理论经济学",
  "理论与应用力学",
  "力学",
  "历史建筑保护工程",
  "历史学",
  "立陶宛语",
  "联合作战学",
  "联合作战指挥",
  "粮食工程",
  "量子信息科学",
  "林产化工",
  "林学",
  "林业",
  "林业工程",
  "临床工程技术",
  "临床药学",
  "临床医学",
  "零售业管理",
  "流行舞蹈",
  "流行音乐",
  "隆迪语",
  "卢森堡语",
  "卢旺达语",
  "录音艺术",
  "旅游地学与规划工程",
  "旅游管理",
  "旅游管理与服务教育",
  "伦理学",
  "轮机工程",
  "罗马尼亚语",
  "逻辑学",
  "麻醉学",
  "马达加斯加语",
  "马耳他语",
  "马克思主义理论",
  "马来语",
  "马其顿语",
  "马术运动与管理",
  "马业科学",
  "漫画",
  "毛利语",
  "贸易经济",
  "美术教育",
  "美术学",
  "美术与书法",
  "蒙古语",
  "蒙药学",
  "蒙医学",
  "孟加拉语",
  "秘书学",
  "密码",
  "密码科学与技术",
  "缅甸语",
  "民族学",
  "木材科学与工程",
  "木结构建筑与材料",
  "纳米材料与技术",
  "纳米科学与工程",
  "内部审计",
  "能源动力",
  "能源服务工程",
  "能源互联网工程",
  "能源化学",
  "能源化学工程",
  "能源经济",
  "能源与动力工程",
  "能源与环境系统工程",
  "尼泊尔语",
  "酿酒工程",
  "纽埃语",
  "农村区域发展",
  "农林经济管理",
  "农林智能装备工程",
  "农学",
  "农药化肥",
  "农业",
  "农业电气化",
  "农业工程",
  "农业机械化及其自动化",
  "农业建筑环境与能源工程",
  "农业水利工程",
  "农业智能装备工程",
  "农业资源与环境",
  "农艺教育",
  "女性学",
  "挪威语",
  "旁遮普语",
  "烹饪与营养教育",
  "皮金语",
  "葡萄牙语",
  "葡萄与葡萄酒工程",
  "普什图语",
  "气象",
  "气象技术与工程",
  "汽车服务工程",
  "汽车维修工程教育",
  "抢险救援指挥与技术",
  "切瓦语",
  "氢能科学与工程",
  "轻工技术与工程",
  "轻化工程",
  "区块链工程",
  "区域国别学",
  "曲艺",
  "全球健康学",
  "人工智能",
  "人居环境科学与技术",
  "人类学",
  "人力资源管理",
  "人文地理与城乡规划",
  "人文教育",
  "认知科学与技术",
  "日语",
  "融合教育",
  "柔性电子学",
  "乳品工程",
  "软件工程",
  "软物质科学与工程",
  "瑞典语",
  "萨摩亚语",
  "塞尔维亚语",
  "塞苏陀语",
  "桑戈语",
  "森林保护",
  "森林工程",
  "僧伽罗语",
  "商务经济学",
  "商务英语",
  "绍纳语",
  "设计",
  "设计学",
  "设施农业科学与工程",
  "社会工作",
  "社会体育指导与管理",
  "社会学",
  "社会政策",
  "社区矫正",
  "涉外警务",
  "摄影",
  "神经科学",
  "审计",
  "审计学",
  "生态修复学",
  "生态学",
  "生物材料",
  "生物工程",
  "生物技术",
  "生物科学",
  "生物农药科学与工程",
  "生物统计学",
  "生物信息学",
  "生物学",
  "生物医学",
  "生物医学工程",
  "生物医学科学",
  "生物医药数据科学",
  "生物与医药",
  "生物育种技术",
  "生物育种科学",
  "生物制药",
  "生物质科学与工程",
  "生物质能源与材料",
  "声学",
  "湿地保护与恢复",
  "石油工程",
  "石油与天然气工程",
  "时尚传播",
  "实验动物学",
  "实验艺术",
  "食品安全与检测",
  "食品科学与工程",
  "食品卫生与营养学",
  "食品药品环境犯罪侦查技 术",
  "食品营养与检验教育",
  "食品营养与健康",
  "食品与营养",
  "食品质量与安全",
  "食用菌科学与工程",
  "世界史",
  "世界语",
  "市场营销",
  "市场营销教育",
  "视觉传达设计",
  "手语翻译",
  "兽医",
  "兽医公共卫生",
  "兽医学",
  "书法学",
  "数据计算及应用",
  "数据警务技术",
  "数据科学",
  "数据科学与大数据技术",
  "数理基础科学",
  "数学",
  "数学与应用数学",
  "数字出版",
  "数字经济",
  "数字媒体技术",
  "数字媒体艺术",
  "数字人文",
  "水产",
  "水产养殖学",
  "水利工程",
  "水利科学与工程",
  "水利水电工程",
  "水生动物医学",
  "水声工程",
  "水土保持与荒漠化防治",
  "水土保持与荒漠化防治学",
  "水文与水资源工程",
  "水务工程",
  "水质科学与技术",
  "水族科学与技术",
  "税收学",
  "税务",
  "丝绸设计与工程",
  "司法鉴定学",
  "司法警察学",
  "思想政治教育",
  "斯洛伐克语",
  "斯洛文尼亚语",
  "斯瓦希里语",
  "饲料工程",
  "索马里语",
  "塔吉克语",
  "塔玛齐格特语",
  "泰米尔语",
  "泰语",
  "探测制导与控制技术",
  "碳储科学与工程",
  "汤加语",
  "陶瓷艺术设计",
  "特殊教育",
  "特种能源技术与工程",
  "特种医学",
  "提格雷尼亚语",
  "体能训练",
  "体育",
  "体育教育",
  "体育经济与管理",
  "体育康养",
  "体育旅游",
  "体育学",
  "天文学",
  "铁道工程",
  "铁路警务",
  "听力与言语康复学",
  "通信工程",
  "统计学",
  "投资学",
  "图书馆学",
  "图书情报",
  "涂料工程",
  "土地科学与技术",
  "土地整治工程",
  "土地资源管理",
  "土耳其语",
  "土库曼语",
  "土木、水利与海洋工程",
  "土木、水利与交通工程",
  "土木工程",
  "土木水利",
  "外国语言文学",
  "外国语言与外国历史",
  "外交学",
  "网络安全与执法",
  "网络工程",
  "网络空间安全",
  "网络与新媒体",
  "微电子科学与工程",
  "微机电系统工程",
  "维医学",
  "卫生监督",
  "卫生检验与检疫",
  "卫生教育",
  "未来机器人",
  "文化产业管理",
  "文化遗产",
  "文物",
  "文物保护技术",
  "文物保护与修复",
  "文物与博物馆学",
  "乌尔都语",
  "乌克兰语",
  "乌兹别克语",
  "无机非金属材料工程",
  "无人驾驶航空器系统工程",
  "无障碍管理",
  "武器发射工程",
  "武器系统与工程",
  "武术与民族传统体育",
  "舞蹈",
  "舞蹈编导",
  "舞蹈表演",
  "舞蹈教育",
  "舞蹈学",
  "物理学",
  "物联网工程",
  "物流工程",
  "物流管理",
  "物业管理",
  "西班牙语",
  "希伯来语",
  "希腊语",
  "稀土材料科学与工程",
  "戏剧教育",
  "戏剧学",
  "戏剧影视导演",
  "戏剧影视美术设计",
  "戏剧影视文学",
  "戏剧与影视",
  "戏曲与曲艺",
  "系统科学",
  "系统科学与工程",
  "纤维艺术",
  "乡村治理",
  "香料香精技术与工程",
  "消防工程",
  "消防政治工作",
  "消防指挥",
  "小学教育",
  "心理学",
  "新媒体技术",
  "新媒体艺术",
  "新能源材料与器件",
  "新能源科学与工程",
  "新能源汽车工程",
  "新闻传播学",
  "新闻学",
  "新闻与传播",
  "信息安全",
  "信息对抗技术",
  "信息工程",
  "信息管理与信息系统",
  "信息与计算科学",
  "信息与通信工程",
  "信息资源管理",
  "信用风险管理与法律防控",
  "信用管理",
  "刑事科学技术",
  "行星科学",
  "行政管理",
  "匈牙利语",
  "休闲体育",
  "虚拟现实技术",
  "学前教育",
  "亚美尼亚语",
  "烟草",
  "眼视光学",
  "眼视光医学",
  "养老服务管理",
  "遥感科学与技术",
  "药事管理",
  "药物分析",
  "药物化学",
  "药物制剂",
  "药学",
  "冶金工程",
  "野生动物与自然保护区管 理",
  "医工学",
  "医疗保险",
  "医疗产品管理",
  "医学技术",
  "医学检验技术",
  "医学实验技术",
  "医学信息工程",
  "医学影像技术",
  "医学影像学",
  "仪器科学与技术",
  "移民管理",
  "艺术管理",
  "艺术教育",
  "艺术设计学",
  "艺术史论",
  "艺术学",
  "艺术与科技",
  "意大利语",
  "音乐",
  "音乐表演",
  "音乐教育",
  "音乐剧",
  "音乐学",
  "音乐治疗",
  "印地语",
  "印度尼西亚语",
  "印刷工程",
  "应急管理",
  "应急技术与管理",
  "应急装备技术与工程",
  "应用电子技术教育",
  "应用化学",
  "应用经济学",
  "应用伦理",
  "应用气象学",
  "应用生物科学",
  "应用统计",
  "应用统计学",
  "应用物理学",
  "应用心理",
  "应用心理学",
  "应用语言学",
  "应用中文",
  "英语",
  "影视技术",
  "影视摄影与制作",
  "邮轮工程与管理",
  "邮政工程",
  "邮政管理",
  "油气储运工程",
  "语言学",
  "预防医学",
  "园林",
  "园艺",
  "园艺教育",
  "园艺学",
  "约鲁巴语",
  "越南语",
  "运动康复",
  "运动能力开发",
  "运动人体科学",
  "运动训练",
  "运动与公共健康",
  "增材制造工程",
  "战略学",
  "战时政治工作",
  "爪哇语",
  "哲学",
  "针灸",
  "针灸推拿学",
  "侦查学",
  "整合科学",
  "政治学",
  "政治学、经济学与哲学",
  "政治学与行政学",
  "知识产权",
  "职业卫生工程",
  "植物保护",
  "植物科学与技术",
  "制药工程",
  "治安学",
  "质量管理工程",
  "智慧海洋技术",
  "智慧建筑与建造",
  "智慧交通",
  "智慧林业",
  "智慧牧业科学与工程",
  "智慧能源工程",
  "智慧农业",
  "智慧水利",
  "智能材料与结构",
  "智能采矿工程",
  "智能测控工程",
  "智能车辆工程",
  "智能地球探测",
  "智能电网信息工程",
  "智能飞行器技术",
  "智能感知工程",
  "智能工程与创意设计",
  "智能海洋装备",
  "智能建造",
  "智能建造与智慧交通",
  "智能交互设计",
  "智能科学与技术",
  "智能视觉工程",
  "智能体育工程",
  "智能无人系统技术",
  "智能医学工程",
  "智能影像工程",
  "智能运输工程",
  "智能制造工程",
  "智能装备与系统",
  "中草药栽培与鉴定",
  "中共党史党建学",
  "中国共产党历史",
  "中国古典学",
  "中国画",
  "中国少数民族语言文学",
  "中国史",
  "中国语言文学",
  "中国语言与文化",
  "中兽医学",
  "中西医结合",
  "中西医临床医学",
  "中药",
  "中药学",
  "中药制药",
  "中药资源与开发",
  "中医",
  "中医儿科学",
  "中医骨伤科学",
  "中医康复学",
  "中医学",
  "中医养生学",
  "种子科学与工程",
  "珠宝首饰设计与工艺",
  "助产学",
  "装甲车辆工程",
  "壮医学",
  "资产评估",
  "资源化学",
  "资源环境大数据工程",
  "资源环境科学",
  "资源勘查工程",
  "资源循环科学与工程",
  "资源与环境",
  "资源与环境经济学",
  "自动化",
  "自然地理与资源环境",
  "自然资源登记与管理",
  "宗教学",
  "足球运动",
  "祖鲁语",
  "作曲与作曲技术理论",
  "作物学",
  "作战指挥保障",
];
